
import { NgModule } from '@angular/core';

import { SearchComponent } from './search.component';
import { TablaSearchModule } from '../buscador-tabla/tabla-search.module';
import { TablaSearchService } from '../buscador-tabla/tabla-search.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        TablaSearchModule,
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
    ],
    declarations: [SearchComponent],
    exports: [SearchComponent],
    providers: [
        TablaSearchService
    ]
})
export class SearchModule { }
